<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :title="$t('invoice.title')"
    :show-close="true"
    custom-class="invoice-dialog"
    append-to-body
  >
    <div slot="title" class="dialog-title">
      <span style="font-size: 16px; font-weight: bold; color: #333;">{{ $t('order.invoiceInfo') }}</span>
    </div>
    
    <div class="invoice-content">
      <!-- 发票类型 -->
      <!-- <div class="form-item">
        <div class="label">{{ $t('order.invoiceType') }}：</div>
        <div class="input-content">
          <div class="radio-group">
            <div 
              class="radio-btn" 
              :class="{ active: formData.type === 1 }"
              @click="formData.type = 1"
            >
              {{ $t('order.generalInvoice') }}
            </div>
            <div 
              class="radio-btn" 
              :class="{ active: formData.type === 2 }"
              @click="formData.type = 2"
            >
              {{ $t('order.specialInvoice') }}
            </div>
          </div>
          <div class="tip-text">
            {{ $t('order.invoiceTip') }}
          </div>
        </div>
      </div> -->

      <!-- 发票抬头 -->
      <div class="form-item">
        <div class="label">{{ $t('order.invoiceHeader') }}：</div>
        <div class="input-content">
          <div class="radio-group">
            <div 
              class="radio-btn" 
              :class="{ active: formData.headerType === 1 }"
              @click="formData.headerType = 1"
            >
              {{ $t('order.personal') }}
            </div>
            <div 
              class="radio-btn" 
              :class="{ active: formData.headerType === 2 }"
              @click="formData.headerType = 2"
            >
              {{ $t('order.company') }}
            </div>
          </div>
          
          <!-- 抬头输入框 -->
          <div class="mt-15">
            <el-input 
              v-model="formData.headerName" 
              :placeholder="formData.headerType === 1 ? $t('order.inputPersonalHeader') : $t('order.inputCompanyHeader')"
            ></el-input>
          </div>

          <!-- 税号输入框 (仅单位显示) -->
          <div class="mt-15" v-if="formData.headerType === 2">
            <el-input 
              v-model="formData.taxNumber" 
              :placeholder="$t('order.inputDutyNumber')"
            ></el-input>
          </div>
        </div>
      </div>

      <!-- 电子邮箱 -->
      <div class="form-item">
        <div class="label">{{ $t('order.email') }}：</div>
        <div class="input-content">
          <el-input 
            v-model="formData.email" 
            :placeholder="$t('order.inputEmail')"
          ></el-input>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="btn-group">
        <div class="btn confirm" :class="{ loading: submitLoading }" @click="handleSave" :style="{ cursor: submitLoading ? 'not-allowed' : 'pointer' }">
          <i v-if="submitLoading" class="el-icon-loading"></i>
          <span>{{ submitLoading ? $t('order.submitting') : $t('order.save') }}</span>
        </div>
        <div class="btn cancel" @click="handleClose" :style="{ cursor: submitLoading ? 'not-allowed' : 'pointer' }">{{ $t('order.cancel') }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "InvoiceModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String | Number,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  data() {
    return {
      submitLoading: false,
      formData: {
        headerType: 1, // 1: 个人, 2: 单位
        headerName: "",
        taxNumber: "",
        email: ""
      }
    };
  },
  created() {
    this.formData.headerName = this.$t('order.personal');
  },
  watch: {
    'formData.headerType'(val) {
      if (val === 1) {
        this.formData.headerName = this.$t('order.personal');
      } else {
        this.formData.headerName = "";
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleSave() {
      if (this.submitLoading) return;
      
      if (!this.formData.headerName) {
        this.$message.error(this.$t('order.inputHeaderNameWarn'));
        return;
      }
      if (this.formData.headerType === 2 && !this.formData.taxNumber) {
        this.$message.error(this.$t('order.inputDutyNumberWarn'));
        return;
      }
      if (this.formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.$message.error(this.$t('order.inputEmailWarn'));
        return;
      }
      
      this.submitLoading = true;
      this.$axios.post('/api/center/applyInvoice', {
        order_id: this.id,
        type: this.formData.headerType,
        title: this.formData.headerName,
        tax_number: this.formData.taxNumber,
        email: this.formData.email
      }).then(res => {
        this.submitLoading = false;
        this.$message.success(this.$t('message.login.operationSU'));
        this.$emit("save", this.formData);
        this.handleClose();
      }).catch(err => {
        this.submitLoading = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .invoice-dialog {
  border-radius: 4px;
  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    .el-dialog__headerbtn {
      top: 20px;
    }
  }
  .el-dialog__body {
    padding: 30px 40px;
  }
  .el-dialog__footer {
    padding: 0 0 30px;
    text-align: center;
  }
}

.invoice-content {
  .form-item {
    display: flex;
    margin-bottom: 25px;
    
    .label {
      width: 80px;
      padding-top: 10px;
      color: #666;
      font-size: 14px;
    }
    
    .input-content {
      flex: 1;
    }
  }

  .radio-group {
    display: flex;
    gap: 20px;
    
    .radio-btn {
      width: 160px;
      height: 40px;
      line-height: 38px;
      text-align: center;
      border: 1px solid #ddd;
      border-radius: 2px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
      
      &.active {
        border-color: #e93323;
        color: #e93323;
        position: relative;
      }
    }
  }

  .tip-text {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
    line-height: 1.5;
  }

  .mt-15 {
    margin-top: 15px;
  }
}

.dialog-footer {
  .btn-group {
    display: flex;
    justify-content: center;
    gap: 20px;
    
    .btn {
      width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 2px;
      cursor: pointer;
      font-size: 14px;
      
      &.confirm {
        background: #e93323;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        &:hover {
          background: #d12d1f;
        }
        &.loading {
          opacity: 0.7;
          cursor: not-allowed !important;
        }
      }
      
      &.cancel {
        background: #999;
        color: #fff;
        &:hover {
          background: #a6a6a6;
        }
      }
    }
  }
}
</style>